import React, { useEffect, useState } from "react";
import TopBarAds from "../Components/TopBarAds";
import FooterBottom from "../Components/FooterBottom";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../Style/otherpages.css";
import "../Style/newssec.css";
import TopBar from "../Components/TopBar";

function OtherPages() {
  const { id } = useParams();
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);
  let url = "https://nland.onrender.com/newpage/" + id;
  useEffect(() => {
    setLoading(true);
    console.log("id", url);
    axios.get(url).then((res) => {
      setLoading(true);
      setData([...res.data]);

      setLoading(false);
    });
  }, [id]);
  return (
    <div className="otherpages">
      <TopBar />
      <div className="ophead">
        <span>Featured News</span>
        <span>Nairaland Forum / Featured News & Discussions</span>
      </div>
      <div className="op_pagesbottom">
        <a href="/news/1">(1)</a>
        <a href="/news/2">(2)</a>
        <a href="/news/3">(3)</a>
        <a href="/news/4">(4)</a>
        <a href="/news/5">(5)</a>
        <a href="/news/6">(6)</a>
        <a href="/news/7">(7)</a>
        <a href="/news/8">(8)</a>
        <a href="/news/9">(9)</a>
        <a href="/news/10">(10)</a>
        <a href="/news/11">(11)</a>
        <div>
          (of <b>5640 </b> pages)
        </div>
      </div>
      <div className="op_newspage">
        <div className="op_mid">
          {loading ? (
            <h2>Loading....</h2>
          ) : (
            data &&
            data.map((res, index) => {
              let title = res.title;
              let url = encodeURIComponent(res.url);
              console.log(url);
              return (
                <a className="op_mid-news" key={index} href={"/open/" + url}>
                  <div dangerouslySetInnerHTML={{ __html: title && title }} />
                </a>
              );
            })
          )}
        </div>
      </div>
      <div className="op_pagesbottom">
        <a href="/news/1">(1)</a>
        <a href="/news/2">(2)</a>
        <a href="/news/3">(3)</a>
        <a href="/news/4">(4)</a>
        <a href="/news/5">(5)</a>
        <a href="/news/6">(6)</a>
        <a href="/news/7">(7)</a>
        <a href="/news/8">(8)</a>
        <a href="/news/9">(9)</a>
        <a href="/news/10">(10)</a>
        <a href="/news/11">(11)</a>
        <div>
          (of <b>5640 </b> pages)
        </div>
      </div>
      <div className="up">(Go up)</div>
      <FooterBottom />
    </div>
  );
}

export default OtherPages;
